module.exports = __webpack_public_path__ + "img/autokast_svalbard.286cac46.jpg";